<template>
  <div @click="download" class="btn download">
    <svg width="25px" height="30px" viewBox="0 0 25 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
        <title>Combined Shape</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Desktop-HD" transform="translate(-207.000000, -566.000000)" fill="#000000" fill-rule="nonzero">
                <g id="Group-4" transform="translate(188.000000, 550.000000)">
                    <g id="Group-2">
                        <path d="M43.4186047,41.8139535 L43.4186047,46 L19,46 L19,41.8139535 L43.4186047,41.8139535 Z M36.4418605,16 L36.4418605,24.372093 L43.4186047,24.372093 L43.4186047,28.5581395 L39.9302326,28.5581395 L39.9302326,32.0465116 L36.4418605,32.0465116 L36.4418605,35.5348837 L32.9534884,35.5348837 L32.9534884,39.0232558 L29.4651163,39.0232558 L29.4651163,35.5348837 L25.9767442,35.5348837 L25.9767442,32.0465116 L22.4883721,32.0465116 L22.4883721,28.5581395 L19,28.5581395 L19,24.372093 L25.9767442,24.372093 L25.9767442,16 L36.4418605,16 Z" id="Combined-Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
  import { storage, storageRef } from "../../firebase";
  import { saveAs } from 'file-saver';

  export default {
    name: 'Download',
    props: [ 'image' ],
    data() {
      return {};
    },
    methods: {
      download() {
        let httpsReference = storage.refFromURL(this.image);

        storageRef.child(httpsReference.fullPath).getDownloadURL().then(function(url) {

          var xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          xhr.onload = function() {
            var blob = xhr.response;
            saveAs(blob, 'milkshake-holiday-party.gif');
          };
          xhr.open('GET', url);
          xhr.send();

        }).catch(function(error) {
          console.log('ERROR',error)
        });
      },
    }
  }
</script>